// Temporary place to put themes.
// In the future these should be loaded from a database.
// TODO - Remove things from here which are now delivered via CMS

import { Theme } from '@/models/instance';

export enum ThemeIds {
    default = 'default',
    Titan = 'titan',
    Phobos = 'phobos',
    Hyperion = 'hyperion',
    Mimas = 'mimas',
    Rana = 'rana',
    Deimos = 'deimos',
    Umbra = 'umbra',
}

export const defaultTheme: Theme = {
    themeId: ThemeIds.default,
    title: '',
    loaded: false,
    assetBasePath: '/assets',
    fonts: {
        primary: 'Arial',
        secondary: 'Times New Roman',
        tertiary: 'Courier New',
        quaternary: 'Courier New',
    },
    files: {
        logo: '',
        // splash_bg: '',
        inventory_backdrop: '',
        instance_mark: '',
    },
    tokens: {
        AriseTheme1RarityRarityCommonLight: '#7f8693ff',
        AriseTheme1RarityRarityCommonMid: '#292f3aff',
        AriseTheme1RarityRarityCommonDark: '#1c2129ff',
        AriseTheme1RarityRarityUncommonLight: '#8fff97ff',
        AriseTheme1RarityRarityUncommonMid: '#265d3fff',
        AriseTheme1RarityRarityUncommonDark: '#12251bff',
        AriseTheme1RarityRarityRareLight: '#a7f0feff',
        AriseTheme1RarityRarityRareMid: '#19646fff',
        AriseTheme1RarityRarityRareDark: '#0e2f34ff',
        AriseTheme1RarityRarityEpicLight: '#e569fbff',
        AriseTheme1RarityRarityEpicMid: '#582f59ff',
        AriseTheme1RarityRarityEpicDark: '#3a1f3bff',
        AriseTheme1RarityRarityLegendaryLight: '#fd8917ff',
        AriseTheme1RarityRarityLegendaryMid: '#803e18ff',
        AriseTheme1RarityRarityLegendaryDark: '#40210fff',
        AriseTheme1StateStateErrorLight: '#fc3232ff',
        AriseTheme1StateStateErrorMid: '#7f0b10ff',
        AriseTheme1StateStateErrorDark: '#200506ff',
        AriseTheme1StateStateSuccessLight: '#8fff97ff',
        AriseTheme1StateStateSuccessMid: '#265d3fff',
        AriseTheme1StateStateSuccessDark: '#12251bff',
        AriseTheme1StateStateDefaultLight: '#7f8693ff',
        AriseTheme1StateStateDefaultMid: '#292f3aff',
        AriseTheme1StateStateDefaultDark: '#1c2129ff',
        AriseTheme1UpdatesUpdatesPositiveLight: '#8FFF97',
        AriseTheme1UpdatesUpdatesPositiveMid: '#265D3F',
        AriseTheme1UpdatesUpdatesPositiveDark: '#12251B',
        AriseTheme1UpdatesUpdatesGeneralLight: '#A7F0FE',
        AriseTheme1UpdatesUpdatesGeneralMid: '#19646F',
        AriseTheme1UpdatesUpdatesGeneralDark: '#0F454D',
        AriseTheme1UpdatesUpdatesAchievementLight: '#FD8917',
        AriseTheme1UpdatesUpdatesAchievementMid: '#803E18',
        AriseTheme1UpdatesUpdatesAchievementDark: '#4B240D',
        AriseTheme1UpdatesUpdatesNegativeLight: '#FC3232',
        AriseTheme1UpdatesUpdatesNegativeMid: '#7F0B10',
        AriseTheme1UpdatesUpdatesNegativeDark: '#200506',
        AccentTheme1InterfaceMonoInterfaceMonoWhite: '#ffffffff',
        AccentTheme1InterfaceMonoInterfaceMonoActive: '#bdbdbdff',
        AccentTheme1InterfaceMonoInterfaceMonoForeground: '#878787ff',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#2c2c2cff',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#171717ff',
        AccentTheme1InterfaceMonoInterfaceMonoBlack: '#000000ff',
        AccentTheme1InterfaceBrandInterfaceActive: '#a8a8a8ff',
        AccentTheme1InterfaceBrandInterfaceForeground: '#6d6d6dff',
        AccentTheme1InterfaceBrandInterfaceMidground: '#2f2f2fff',
        AccentTheme1InterfaceBrandInterfaceBackground: '#191919ff',
        AccentTheme1BorderBorderDefault: '#9b9b9bff',
        AccentTheme1BorderBorderHighlight: '#c4c4c4ff',
        AccentTheme1BorderBorderInactive: '#5c5c5cff',
        AccentTheme1BorderBorderActive: '#d8d8d8ff',
        AccentTheme1BrandPaletteBrandAccent1: '#b3b3b3ff',
        AccentTheme1BrandPaletteBrandAccent2: '#262626',
        AccentTheme1BrandPaletteBrandContrast1: '#a0a0a0ff',
        AccentTheme1BrandPaletteBrandContrast2: '#8b8b8bff',
        AccentTheme1BrandPaletteBrandScale1: '#adadadff',
        AccentTheme1BrandPaletteBrandScale2: '#878787ff',
        AccentTheme1BrandPaletteBrandScale3: '#3f3f3fff',
        AccentTheme1BrandPaletteBrandColour: '#262626',
        AccentTheme1BrandPaletteBrandColourContrast: '#ffffffff',
        AccentTheme1ButtonButtonDefault: '#9b9b9bff',
        AccentTheme1ButtonButtonHighlight: '#a8a8a8ff',
        AccentTheme1ButtonButtonActive: '#b7b7b7ff',
        AccentTheme1ButtonButtonInactive: '#545454ff',
        AccentTheme1ButtonButtonSecondaryDefault: '#666666',
        AccentTheme1ButtonButtonSecondaryHighlight: '#b5b5b5ff',
        AccentTheme1ButtonButtonSecondaryActive: '#c4c4c4ff',
        AccentTheme1ButtonButtonSecondaryInactive: '#3f3f3fff',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1TextTextInactive: '#a6a6a6',
        AccentTheme1TextTextBrand2: '#999999ff',
        AccentTheme1TextTextBrand1: '#9b9b9bff',
        AccentTheme1TextTextContrastDefault: '#151515ff',
        AccentTheme1TextTextLink: '#878787ff', // Added manually for now
        // LEGACY
        LEGACYAccentTheme1ButtonButtonSecondary: '#3a3a3aff',
        LEGACYAccentTheme1TextTextActive: '#ffffffff',
        LEGACYAccentTheme1TextTextSecondary: '#9d9d9dff',
        LEGACYAccentTheme1InterfaceInterfaceActive: '#9d9d9dff',
        LEGACYAccentTheme1InterfaceInterfaceForeground: '#2a2a2aff',
        LEGACYAccentTheme1InterfaceInterfaceMidground: '#141414ff',
        LEGACYAccentTheme1InterfaceInterfaceBackground: '#0f0f0fff',
        LEGACYAccentTheme1InterfaceInterfaceWhite: '#ffffffff',
        LEGACYAccentTheme1InterfaceInterfaceGrey: '#828282ff',
        LEGACYAccentTheme1InterfaceInterfaceBlack: '#0b0b0bff',
        LEGACYAccentTheme1BrandColour: '#8c8c8cff',
        LEGACYAccentTheme1BrandColourContrast: '#0b0b0bff',
    },
    customJSON: {},
};

export const TitanTheme: Theme = {
    ...defaultTheme,
    themeId: ThemeIds.Titan,
    fonts: {
        primary: 'CheapSignage',
        secondary: 'Alexandria',
        tertiary: 'Inter',
        quaternary: 'Oswald',
    },
    tokens: {
        ...defaultTheme.tokens,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: '#ffffffff',
        AccentTheme1InterfaceMonoInterfaceMonoActive: '#d7d7d7ff',
        AccentTheme1InterfaceMonoInterfaceMonoForeground: '#a5a5a5ff',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#2c2c2cff',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#1b1b1bff',
        AccentTheme1InterfaceMonoInterfaceMonoBlack: '#000000ff',
        AccentTheme1InterfaceBrandInterfaceActive: '#BCA8A8',
        AccentTheme1InterfaceBrandInterfaceForeground: '#796262',
        AccentTheme1InterfaceBrandInterfaceMidground: '#2A2E36',
        AccentTheme1InterfaceBrandInterfaceBackground: '#0F0F0F',
        AccentTheme1BorderBorderDefault: '#8e1f22ff',
        AccentTheme1BorderBorderHighlight: '#f02d32ff',
        AccentTheme1BorderBorderInactive: '#690508ff',
        AccentTheme1BorderBorderActive: '#fb3b40ff',
        AccentTheme1BrandPaletteBrandAccent1: '#d42126ff',
        AccentTheme1BrandPaletteBrandAccent2: '#d42126ff', // Changed this manually for event colours
        AccentTheme1BrandPaletteBrandContrast1: '#93b6c6ff',
        AccentTheme1BrandPaletteBrandContrast2: '#57b4ddff',
        AccentTheme1BrandPaletteBrandScale1: '#d4a98aff',
        AccentTheme1BrandPaletteBrandScale2: '#a77e61ff',
        AccentTheme1BrandPaletteBrandScale3: '#3f3128ff',
        AccentTheme1BrandPaletteBrandColour: '#d42126ff',
        AccentTheme1BrandPaletteBrandColourContrast: '#ffffffff',
        AccentTheme1ButtonButtonDefault: '#d42126ff',
        AccentTheme1ButtonButtonHighlight: '#ff604bff',
        AccentTheme1ButtonButtonActive: '#ff2e00ff',
        AccentTheme1ButtonButtonInactive: '#3f1f1fff',
        AccentTheme1ButtonButtonSecondaryDefault: '#a7a7a7ff',
        AccentTheme1ButtonButtonSecondaryHighlight: '#cececeff',
        AccentTheme1ButtonButtonSecondaryActive: '#d8d8d8ff',
        AccentTheme1ButtonButtonSecondaryInactive: '#505050ff',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1TextTextInactive: '#505050ff',
        AccentTheme1TextTextBrand2: '#ca8e54ff',
        AccentTheme1TextTextBrand1: '#ff473bff',
        AccentTheme1TextTextContrastDefault: '#151515ff',
        AccentTheme1TextTextLink: '#a5a5a5ff', // Added manually for now
        // LEGACY
        LEGACYAccentTheme1ButtonButtonSecondary: '#dcdcdcff',
        LEGACYAccentTheme1TextTextActive: '#ffffffff',
        LEGACYAccentTheme1TextTextSecondary: '#dcdcdcff',
        LEGACYAccentTheme1InterfaceInterfaceActive: '#ffffffff',
        LEGACYAccentTheme1InterfaceInterfaceForeground: '#3d3d3dff',
        LEGACYAccentTheme1InterfaceInterfaceMidground: '#1e1e1eff',
        LEGACYAccentTheme1InterfaceInterfaceBackground: '#151515ff',
        LEGACYAccentTheme1InterfaceInterfaceWhite: '#ffffffff',
        LEGACYAccentTheme1InterfaceInterfaceGrey: '#bdbdbdff',
        LEGACYAccentTheme1InterfaceInterfaceBlack: '#000000ff',
        LEGACYAccentTheme1BrandColour: '#e81f25ff',
        LEGACYAccentTheme1BrandColourContrast: '#ffffffff',
    },
};

export const PhobosTheme: Theme = {
    ...defaultTheme,
    themeId: ThemeIds.Phobos,
    fonts: {
        primary: 'ChakraPetchTitle',
        secondary: 'ChakraPetch',
        tertiary: 'ChakraPetch',
        quaternary: 'ChakraPetch',
    },
    tokens: {
        ...TitanTheme.tokens,
    },
};

export const HyperionTheme: Theme = {
    ...defaultTheme,
    themeId: ThemeIds.Hyperion,
    fonts: {
        primary: 'ChakraPetchTitle',
        secondary: 'ChakraPetch',
        tertiary: 'ChakraPetch',
        quaternary: 'HomePlanetBB',
    },
    tokens: {
        ...defaultTheme.tokens,
        AccentTheme1InterfaceMonoInterfaceMonoWhite: '#ffffffff',
        AccentTheme1InterfaceMonoInterfaceMonoActive: '#d7d7d7ff',
        AccentTheme1InterfaceMonoInterfaceMonoForeground: '#a5a5a5ff',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#2c2c2cff',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#1b1b1bff',
        AccentTheme1InterfaceMonoInterfaceMonoBlack: '#000000ff',
        AccentTheme1InterfaceBrandInterfaceActive: '#a8b2bcff',
        AccentTheme1InterfaceBrandInterfaceForeground: '#626b79ff',
        AccentTheme1InterfaceBrandInterfaceMidground: '#2a2e36ff',
        AccentTheme1InterfaceBrandInterfaceBackground: '#15191fff',
        AccentTheme1BorderBorderDefault: '#0ab4f3ff',
        AccentTheme1BorderBorderHighlight: '#2fc6ffff',
        AccentTheme1BorderBorderInactive: '#0d8ebfff',
        AccentTheme1BorderBorderActive: '#42c9fcff',
        AccentTheme1BrandPaletteBrandAccent1: '#00a0dcff',
        AccentTheme1BrandPaletteBrandAccent2: '#fbee23ff',
        AccentTheme1BrandPaletteBrandContrast1: '#ffffffff',
        AccentTheme1BrandPaletteBrandContrast2: '#000000ff',
        AccentTheme1BrandPaletteBrandScale1: '#5bd2ffff',
        AccentTheme1BrandPaletteBrandScale2: '#00a0dcff',
        AccentTheme1BrandPaletteBrandScale3: '#0c6485ff',
        AccentTheme1BrandPaletteBrandColour: '#00a0dcff',
        AccentTheme1BrandPaletteBrandColourContrast: '#ffffffff',
        AccentTheme1ButtonButtonDefault: '#00a0dcff',
        AccentTheme1ButtonButtonHighlight: '#0ab4f3ff',
        AccentTheme1ButtonButtonActive: '#00b9ffff',
        AccentTheme1ButtonButtonInactive: '#003447ff',
        AccentTheme1ButtonButtonSecondaryDefault: '#a7a7a7ff',
        AccentTheme1ButtonButtonSecondaryHighlight: '#cececeff',
        AccentTheme1ButtonButtonSecondaryActive: '#d8d8d8ff',
        AccentTheme1ButtonButtonSecondaryInactive: '#505050ff',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1TextTextInactive: '#505050ff',
        AccentTheme1TextTextBrand2: '#ca8e54ff',
        AccentTheme1TextTextBrand1: '#00a0dcff',
        AccentTheme1TextTextContrastDefault: '#151515ff',
        AccentTheme1TextTextLink: '#a5a5a5ff', // Added manually for now
    },
};

export const MimasTheme: Theme = {
    ...defaultTheme,
    themeId: ThemeIds.Mimas,
    fonts: {
        primary: 'ChakraPetchTitle',
        secondary: 'ChakraPetch',
        tertiary: 'ChakraPetch',
        quaternary: 'ChakraPetch',
    },
    tokens: {
        ...defaultTheme.tokens,
        AccentTheme1ButtonButtonDefault: '#FF6A00',
        AccentTheme1BrandPaletteBrandColour: '#FF6A00',
        AccentTheme1BrandPaletteBrandAccent1: '#FFAA01',
        AriseTheme1UpdatesUpdatesPositiveLight: '#CCCCCC',
        AriseTheme1UpdatesUpdatesPositiveMid: '#555555',
        AriseTheme1UpdatesUpdatesPositiveDark: '#0E0E0E',
        AriseTheme1UpdatesUpdatesGeneralLight: '#FFFFFF',
        AriseTheme1UpdatesUpdatesGeneralMid: '#909090',
        AriseTheme1UpdatesUpdatesGeneralDark: '#6B6B6B',
        AriseTheme1UpdatesUpdatesAchievementLight: '#FFEADA',
        AriseTheme1UpdatesUpdatesAchievementMid: '#FF6A00',
        AriseTheme1UpdatesUpdatesAchievementDark: '#A44400',
        AriseTheme1UpdatesUpdatesNegativeLight: '#FC3232',
        AriseTheme1UpdatesUpdatesNegativeMid: '#7F0B10',
        AriseTheme1UpdatesUpdatesNegativeDark: '#200506',
        AriseTheme1StateStateErrorLight: '#FFFFFF',
        AriseTheme1StateStateErrorMid: '#909090',
        AriseTheme1StateStateErrorDark: '#6B6B6B',
        AriseTheme1StateStateSuccessLight: '#CCCCCC',
        AriseTheme1StateStateSuccessMid: '#0E0E0E',
        AriseTheme1StateStateSuccessDark: '#0E0E0E',
    },
};

export const RanaTheme: Theme = {
    ...defaultTheme,
    themeId: ThemeIds.Rana,
};

export const DeimosTheme: Theme = {
    ...defaultTheme,
    themeId: ThemeIds.Deimos,
    fonts: {
        primary: 'ChakraPetchTitle',
        secondary: 'ChakraPetch',
        tertiary: 'ChakraPetch',
        quaternary: 'ChakraPetch',
    },
};

export const UmbraTheme: Theme = {
    ...defaultTheme,
    themeId: ThemeIds.Umbra,
    fonts: {
        primary: 'ChakraPetchTitle',
        secondary: 'ChakraPetch',
        tertiary: 'ChakraPetch',
        quaternary: 'ChakraPetch',
    },
    tokens: {
        ...defaultTheme.tokens,
        AccentTheme1InterfaceBrandInterfaceForeground: '#223757ff',
        AccentTheme1InterfaceBrandInterfaceMidground: '#0D2322',
        AccentTheme1InterfaceBrandInterfaceBackground: '#001614',
        AccentTheme1InterfaceMonoInterfaceMonoBackground: '#0D2322',
        AccentTheme1InterfaceMonoInterfaceMonoMidground: '#0D2322',
        AccentTheme1ButtonButtonDefault: '#194543ff',
        AccentTheme1ButtonButtonHighlight: '#0D2322',
        AccentTheme1TextTextDefault: '#ffffffff',
        AccentTheme1BrandPaletteBrandAccent1: '#79DBD6',
        AccentTheme1BrandPaletteBrandColour: '#0D2322',
        AriseTheme1UpdatesUpdatesPositiveLight: '#4390C0',
        AriseTheme1UpdatesUpdatesPositiveMid: '#20394C',
        AriseTheme1UpdatesUpdatesPositiveDark: '#0F1922',
        AriseTheme1UpdatesUpdatesGeneralLight: '#4FA5A2',
        AriseTheme1UpdatesUpdatesGeneralMid: '#274B4C',
        AriseTheme1UpdatesUpdatesGeneralDark: '#0D2322',
        AriseTheme1UpdatesUpdatesAchievementLight: '#79DBD6',
        AriseTheme1UpdatesUpdatesAchievementMid: '#274B4C',
        AriseTheme1UpdatesUpdatesAchievementDark: '#0D2322',
        AriseTheme1UpdatesUpdatesNegativeLight: '#FC3232',
        AriseTheme1UpdatesUpdatesNegativeMid: '#7F0B10',
        AriseTheme1UpdatesUpdatesNegativeDark: '#200506',
        AriseTheme1StateStateErrorLight: '#B55E5D',
        AriseTheme1StateStateErrorMid: '#351D1D',
        AriseTheme1StateStateErrorDark: '#180F0F',
        AriseTheme1StateStateSuccessLight: '#81CFCE',
        AriseTheme1StateStateSuccessMid: '#274B4C',
        AriseTheme1StateStateSuccessDark: '#0D2322',
        AriseTheme1StateStateDefaultLight: '#4390C0',
        AriseTheme1StateStateDefaultMid: '#20394C',
        AriseTheme1StateStateDefaultDark: '#0F1922',
    },
};
